import axios from 'axios'
import { Message } from 'element-ui'
import CONFIG from '@/config'
import storage from '@/model/utils/localStorage'

axios.defaults.baseURL = CONFIG.baseUrl

// 请求白名单
// const whitelist = []

// 请求拦截器
axios.interceptors.request.use(
  config => {
    return config
  },
  error => error
)
// 请求结果拦截器
axios.interceptors.response.use(  
  response => {
    const code = response.data.code
    if (code === 200) {
      return Promise.resolve(response)
    } else {
        if(response.data.msg === '凭证失效'){
            Message.error('登录令牌已失效，请重新登录！')
            setTimeout(() => {                
                storage.clearKeysByUser()
                window.location.reload()
            },1000)
            return Promise.reject(response)
        }

        if(response.data.msg === '没有权限'){
            return Promise.resolve(response)
        }

        const msg = response.data.msg || '未知错误'
        Message.error(msg)
        return Promise.reject(response)
    }
  },
  error => {
    if (!error.response) {
      Message.error('请求出错')
      return Promise.reject(error)
    }
    const code = error.response.status
    if (code === 401) {
      // debugger
      Message.error({
        message: '登录令牌已失效，请重新登录！',
        center: true
      })
      storage.clearKeysByUser()
      window.location.reload()
      return Promise.reject(error.response)
    }
    
    return Promise.reject(error.response)
  }
)

export default axios
